import db from '../db';
import sepet from './sepet';


async function cariSec(guid, api) {
    await db.transaction('rw', db.caris, async () => {

        await db.caris.toCollection().modify(cari => { cari.secili = false; });
        await db.caris.update(guid, { secili: true });
        // await sepet.set(api, await db.caris .where('secili') .equals(true) .first()) //.toArray())  BU İNDEX Lİ Sİ ALAN İNDEX BOOLEN OLAMAZ


    });
    const aktifCari = await db.caris.toCollection().filter(c => c.secili === true).first();
    await sepet.set(api, aktifCari)

}
export default {
    carisec: cariSec
}


// WEBPACK FOOTER //
// ./src/services/cari.js